import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-machine-monitoring',
  templateUrl: './machine-monitoring.component.html',
  styleUrls: ['./machine-monitoring.component.scss']
})
export class MachineMonitoringComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
